import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import withOnline from '../../common/withOnline';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withUser from '../../common/withUser';
import withTeam from '../../common/withTeam';
import withServerUrl from '../../common/withServerUrl';
import Bugsnag from '../../helpers/bugsnag';
import {
  userLogout,
  storeLastVisitedRoute
} from '../../common/globals';
import {
  deleteAllCases,
  deleteDb,
  deleteOfflineSyncCases,
  getUnSubmittedScanSessions
} from '../../utils/db';
import withCalendarFilter from '../../common/withCalendarFilter';
import withScanInventory from '../../common/withScanInventory';
import withScanInventoryScanner from '../../common/withScanInventoryScanner';
import withFirstLoginSessionToken from '../../common/withFirstLoginSessionToken';
import withUpdatedRoute from '../../common/withUpdatedRoute';
import { signout } from '../../utils/utils';

class UnSavedCaseChanges extends Component {
  constructor(props) {
    super(props);
    this.unSubmittedScanSessions = null;
    this.unSavedCaseChanges = null;
  }

  componentDidMount() {
    try {
      this.unSubmittedScanSessions = new window.bootstrap.Modal(window.$('#unSubmittedScanSessionsModal'));
      this.unSavedCaseChanges = new window.bootstrap.Modal(window.$('#unSavedCaseChangesModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickYes = async () => {
    try {
      const {
        setTeam, setLoader, setCalendarFilter, setScanInventory, setScanInventoryScanner,
        setFirstLoginSessionToken, setUpdatedRoute, online
      } = this.props;
      const unSubmittedScanSessions = await getUnSubmittedScanSessions();
      if (online) {
        if (unSubmittedScanSessions !== undefined
          && !unSubmittedScanSessions.length > 0) {
          setLoader(true);
          storeLastVisitedRoute('');
          setUpdatedRoute('');
          setTeam({});
          await deleteDb();
          window.localStorage.clear();
          setCalendarFilter({});
          setScanInventory({});
          setScanInventoryScanner({});
          setFirstLoginSessionToken('');
          setUpdatedRoute('');
          signout().then(async () => {
            await userLogout();
            setLoader(false);
          });
        } else {
          this.unSavedCaseChanges.hide();
          this.unSubmittedScanSessions.show();
          return;
        }
      } else if (!online && unSubmittedScanSessions !== undefined
        && unSubmittedScanSessions.length > 0) {
        this.unSavedCaseChanges.hide();
        this.unSubmittedScanSessions.show();
        return;
      } else {
        storeLastVisitedRoute('');
        setUpdatedRoute('');
        setTeam({});
        // await deleteDb();
        await deleteAllCases();
        await deleteOfflineSyncCases();
        window.localStorage.clear();
        setCalendarFilter({});
        setScanInventory({});
        setScanInventoryScanner({});
        setFirstLoginSessionToken('');
        setUpdatedRoute('');
        browserHistory.push('/');
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (
      <div
        className="modal fade theme-modal" id="unSavedCaseChangesModal"
        tabIndex="-1" aria-labelledby="unSavedCaseChangesModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p className="mb-0">You have cases with unsaved changes.</p>
              <p className="mb-0">These changes will be lost if you log out.</p>
              <p className="mb-0">Continue?</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">No</button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={this._onClickYes}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTeam(
  withServerUrl(
    withUser(
      withOnline(
        withNotify(
          withLoader(
            withCalendarFilter(
              withScanInventory(
                withScanInventoryScanner(
                  withFirstLoginSessionToken(
                    withUpdatedRoute(
                      UnSavedCaseChanges
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
